import * as R from "ramda";
import {
  INSERT_TYPE_BLANK,
  INSERT_TURBO_QUAD_OVAL,
  INSERT_TURBO_QUAD_OVAL_MESH,
  INSERT_TURBO_QUAD_POWER_OVAL,
  INSERT_TURBO_QUAD_2_OVAL_NUBS,
  INSERT_TURBO_QUAD_2_SEMI,
  INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  INSERT_TURBO_QUAD_CLASSIC_OVAL,
  INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  INSERT_TURBO_QUAD_SB_POWER_LIFT,
  INSERT_TURBO_QUAD_SB_SEMI,
  INSERT_TURBO_MISS_QUAD_OVAL,
  INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  INSERT_CONTOUR_SUPERSOFT,
  INSERT_CONTOUR_SEMI_CERISE,
  INSERT_CONTOUR_SILICONE,
  INSERT_VISE_POWER_LIFT,
  INSERT_VISE_SEMI,
  INSERT_VISE_SEMI_7_8,
  INSERT_VISE_POWER_OVAL,
  INSERT_VISE_OVAL,
  INSERT_VISE_OVAL_7_8,
  INSERT_VISE_SILICONE,
  INSERT_VISE_GRAPE_NUBS,
  INSERT_VISE_POWER_LIFT_7_8,
  INSERT_VISE_POWER_OVAL_7_8,
  INSERT_ULTIMATE_TLO_OVAL,
  INSERT_ULTIMATE_TLO_LIFT,
  INSERT_ULTIMATE_TLO_OVAL_7_8,
  INSERT_ULTIMATE_TLO_LIFT_7_8,
  INSERT_JOPO_POWER_FLAT,
  INSERT_JOPO_POWER_OVAL,
  INSERT_JOPO_OVAL,
  INSERT_JOPO_OVAL_DOTS,
} from "./idx_data_insert_types";
import { Fraction } from "fractional";
//Need the sizes to add for the 3 new inserts.

// INSERT_TYPE_BLANK
let order = 0;
let i = 0;
let d = 1;

const idx_data_insert_sizesRAW = [];

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TYPE_BLANK,
  size: "---",
  od: "",
  widthDecimal: 0.0,
});

for (let j = 0; j <= 1; j++) {
  if (j > 0) {
    i = j;
  } else {
    i = "";
  }

  if (i == 1) {
    d = 0;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + "",
      od: i + "",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 1/64",
      od: i + " 1/64",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 1/32",
      od: i + " 1/32",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 3/64",
      od: i + " 3/64",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 1/16",
      od: i + " 1/16",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 5/64",
      od: i + " 5/64",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 3/32",
      od: i + " 3/32",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 7/64",
      od: i + " 7/64",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 1/8",
      od: i + " 1/8",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 9/64",
      od: i + " 9/64",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 5/32",
      od: i + " 5/32",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 11/64",
      od: i + " 11/64",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 3/16",
      od: i + " 3/16",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 13/64",
      od: i + " 13/64",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 7/32",
      od: i + " 7/32",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 15/64",
      od: i + " 15/64",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 1/4",
      od: i + " 1/4",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 17/64",
      od: i + " 17/64",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 9/32",
      od: i + " 9/32",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 19/64",
      od: i + " 19/64",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 5/16",
      od: i + " 5/16",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 21/64",
      od: i + " 21/64",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 11/32",
      od: i + " 11/32",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 23/64",
      od: i + " 23/64",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 3/8",
      od: i + " 3/8",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 25/32",
      od: i + " 25/32",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 13/32",
      od: i + " 13/32",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 27/64",
      od: i + " 27/64",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 7/16",
      od: i + " 7/16",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 29/64",
      od: i + " 29/64",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 15/32",
      od: i + " 15/32",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 31/64",
      od: i + " 31/64",
      widthDecimal: 0.0,
    });
    order++;
    d++;
  }

  d = 32;
  idx_data_insert_sizesRAW.push({
    type_id: INSERT_TYPE_BLANK,
    size: i + " 1/2",
    od: i + " 1/2",
    widthDecimal: 0.0,
  });
  order++;
  d++;

  if (i == 0) {
    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 33/64",
      od: i + " 33/64",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 17/32",
      od: i + " 17/32",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 35/64",
      od: i + " 35/64",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 9/16",
      od: i + " 9/16",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 37/64",
      od: i + " 37/64",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 19/32",
      od: i + " 19/32",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 39/64",
      od: i + " 39/64",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 5/8",
      od: i + " 5/8",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 41/64",
      od: i + " 41/64",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 21/32",
      od: i + " 21/32",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 43/64",
      od: i + " 43/64",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 11/16",
      od: i + " 11/16",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 45/64",
      od: i + " 45/64",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 23/32",
      od: i + " 23/32",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 47/64",
      od: i + " 47/64",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 3/4",
      od: i + " 3/4",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 49/64",
      od: i + " 49/64",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 25/32",
      od: i + " 25/32",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 51/64",
      od: i + " 51/64",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 13/16",
      od: i + " 13/16",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 53/64",
      od: i + " 53/64",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 27/32",
      od: i + " 27/32",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 55/64",
      od: i + " 55/64",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 7/8",
      od: i + " 7/8",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 57/64",
      od: i + " 57/64",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 29/32",
      od: i + " 29/32",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 59/64",
      od: i + " 59/64",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 15/16",
      od: i + " 15/16",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 61/64",
      od: i + " 61/64",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 31/32",
      od: i + " 31/32",
      widthDecimal: 0.0,
    });
    order++;
    d++;

    idx_data_insert_sizesRAW.push({
      type_id: INSERT_TYPE_BLANK,
      size: i + " 63/64",
      od: i + " 63/64",
      widthDecimal: 0.0,
    });
    order++;
    d++;
  }
}

// INSERT_TURBO_QUAD_OVAL
idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "---",
  od: "",
  widthDecimal: 0.0,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "19/32",
  od: "31/32",
  widthDecimal: 0.22,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "39/64",
  od: "31/32",
  widthDecimal: 0.207,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "5/8",
  od: "31/32",
  widthDecimal: 0.197,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "41/64",
  od: "31/32",
  widthDecimal: 0.206,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "21/32",
  od: "31/32",
  widthDecimal: 0.193,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "43/64",
  od: "31/32",
  widthDecimal: 0.183,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "11/16",
  od: "31/32",
  widthDecimal: 0.176,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "45/64",
  od: "31/32",
  widthDecimal: 0.169,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "23/32",
  od: "31/32",
  widthDecimal: 0.166,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "47/64",
  od: "31/32",
  widthDecimal: 0.156,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "3/4",
  od: "31/32",
  widthDecimal: 0.15,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "49/64",
  od: "31/32",
  widthDecimal: 0.157,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "25/32",
  od: "31/32",
  widthDecimal: 0.134,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "51/64",
  od: "31/32",
  widthDecimal: 0.128,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "13/16",
  od: "31/32",
  widthDecimal: 0.126,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "53/64",
  od: "1 1/32",
  widthDecimal: 0.119,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "27/32",
  od: "1 1/32",
  widthDecimal: 0.112,
});

// idx_data_insert_sizesRAW.push({
//   type_id: INSERT_TURBO_QUAD_OVAL,
//   size: "55/64",
//   od: "1 1/32",
//   widthDecimal: 0.0,
// });

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "7/8",
  od: "1 1/32",
  widthDecimal: 0.117,
});

// idx_data_insert_sizesRAW.push({
//   type_id: INSERT_TURBO_QUAD_OVAL,
//   size: "57/64",
//   od: "1 1/32",
//   widthDecimal: 0.0,
// });

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL,
  size: "29/32",
  od: "1 1/32",
  widthDecimal: 0.101,
});

// INSERT_TURBO_QUAD_OVAL_MESH
idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "---",
  od: "",
  widthDecimal: 0.0,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "19/32",
  od: "31/32",
  widthDecimal: 0.22,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "39/64",
  od: "31/32",
  widthDecimal: 0.207,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "5/8",
  od: "31/32",
  widthDecimal: 0.197,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "41/64",
  od: "31/32",
  widthDecimal: 0.206,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "21/32",
  od: "31/32",
  widthDecimal: 0.193,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "43/64",
  od: "31/32",
  widthDecimal: 0.183,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "11/16",
  od: "31/32",
  widthDecimal: 0.176,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "45/64",
  od: "31/32",
  widthDecimal: 0.169,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "23/32",
  od: "31/32",
  widthDecimal: 0.166,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "47/64",
  od: "31/32",
  widthDecimal: 0.156,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "3/4",
  od: "31/32",
  widthDecimal: 0.15,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "49/64",
  od: "31/32",
  widthDecimal: 0.157,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "25/32",
  od: "31/32",
  widthDecimal: 0.134,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "51/64",
  od: "31/32",
  widthDecimal: 0.128,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "13/16",
  od: "31/32",
  widthDecimal: 0.126,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "53/64",
  od: "1 1/32",
  widthDecimal: 0.119,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "27/32",
  od: "1 1/32",
  widthDecimal: 0.112,
});

// idx_data_insert_sizesRAW.push({
//   type_id: INSERT_TURBO_QUAD_OVAL_MESH,
//   size: "55/64",
//   od: "1 1/32",
//   widthDecimal: 0.0,
// });

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "7/8",
  od: "1 1/32",
  widthDecimal: 0.117,
});

// idx_data_insert_sizesRAW.push({
//   type_id: INSERT_TURBO_QUAD_OVAL_MESH,
//   size: "57/64",
//   od: "1 1/32",
//   widthDecimal: 0.0,
// });

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_OVAL_MESH,
  size: "29/32",
  od: "1 1/32",
  widthDecimal: 0.101,
});

// INSERT_TURBO_QUAD_POWER_OVAL
idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "---",
  od: "",
  widthDecimal: 0.0,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "19/32",
  od: "31/32",
  widthDecimal: 0.249,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "39/64",
  od: "31/32",
  widthDecimal: 0.244,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "5/8",
  od: "31/32",
  widthDecimal: 0.24,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "41/64",
  od: "31/32",
  widthDecimal: 0.23,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "21/32",
  od: "31/32",
  widthDecimal: 0.221,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "43/64",
  od: "31/32",
  widthDecimal: 0.215,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "11/16",
  od: "31/32",
  widthDecimal: 0.209,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "45/64",
  od: "31/32",
  widthDecimal: 0.195,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "23/32",
  od: "31/32",
  widthDecimal: 0.182,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "47/64",
  od: "31/32",
  widthDecimal: 0.179,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "3/4",
  od: "31/32",
  widthDecimal: 0.177,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "49/64",
  od: "31/32",
  widthDecimal: 0.169,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "25/32",
  od: "31/32",
  widthDecimal: 0.161,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "51/64",
  od: "31/32",
  widthDecimal: 0.154,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "13/16",
  od: "31/32",
  widthDecimal: 0.147,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "53/64",
  od: "1 1/32",
  widthDecimal: 0.138,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "27/32",
  od: "1 1/32",
  widthDecimal: 0.13,
});

// idx_data_insert_sizesRAW.push({
//   type_id: INSERT_TURBO_QUAD_POWER_OVAL,
//   size: "55/64",
//   od: "1 1/32",
//   widthDecimal: 0.0,
// });

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "7/8",
  od: "1 1/32",
  widthDecimal: 0.145,
});

// idx_data_insert_sizesRAW.push({
//   type_id: INSERT_TURBO_QUAD_POWER_OVAL,
//   size: "57/64",
//   od: "1 1/32",
//   widthDecimal: 0.0,
// });

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_POWER_OVAL,
  size: "29/32",
  od: "1 1/32",
  widthDecimal: 0.122,
});

// INSERT_TURBO_QUAD_2_OVAL_NUBS
idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "---",
  od: "",
  widthDecimal: 0.0,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "19/32",
  od: "31/32",
  widthDecimal: 0.222,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "39/64",
  od: "31/32",
  widthDecimal: 0.207,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "5/8",
  od: "31/32",
  widthDecimal: 0.197,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "41/64",
  od: "31/32",
  widthDecimal: 0.195,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "21/32",
  od: "31/32",
  widthDecimal: 0.193,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "43/64",
  od: "31/32",
  widthDecimal: 0.183,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "11/16",
  od: "31/32",
  widthDecimal: 0.176,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "45/64",
  od: "31/32",
  widthDecimal: 0.169,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "23/32",
  od: "31/32",
  widthDecimal: 0.165,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "47/64",
  od: "31/32",
  widthDecimal: 0.156,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "3/4",
  od: "31/32",
  widthDecimal: 0.15,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "49/64",
  od: "31/32",
  widthDecimal: 0.143,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "25/32",
  od: "31/32",
  widthDecimal: 0.132,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "51/64",
  od: "31/32",
  widthDecimal: 0.128,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "13/16",
  od: "31/32",
  widthDecimal: 0.127,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "53/64",
  od: "1 1/32",
  widthDecimal: 0.119,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "27/32",
  od: "1 1/32",
  widthDecimal: 0.112,
});

// idx_data_insert_sizesRAW.push({
//   type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
//   size: "55/64",
//   od: "1 1/32",
//   widthDecimal: 0.0,
// });

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "7/8",
  od: "1 1/32",
  widthDecimal: 0.107,
});

// idx_data_insert_sizesRAW.push({
//   type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
//   size: "57/64",
//   od: "1 1/32",
//   widthDecimal: 0.0,
// });

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_OVAL_NUBS,
  size: "29/32",
  od: "1 1/32",
  widthDecimal: 0.101,
});

// INSERT_TURBO_QUAD_2_SEMI
idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "---",
  od: "",
  widthDecimal: 0.0,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "19/32",
  od: "31/32",
  widthDecimal: 0.256,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "39/64",
  od: "31/32",
  widthDecimal: 0.245,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "5/8",
  od: "31/32",
  widthDecimal: 0.243,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "41/64",
  od: "31/32",
  widthDecimal: 0.232,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "21/32",
  od: "31/32",
  widthDecimal: 0.227,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "43/64",
  od: "31/32",
  widthDecimal: 0.22,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "11/16",
  od: "31/32",
  widthDecimal: 0.213,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "45/64",
  od: "31/32",
  widthDecimal: 0.194,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "23/32",
  od: "31/32",
  widthDecimal: 0.19,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "47/64",
  od: "31/32",
  widthDecimal: 0.184,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "3/4",
  od: "31/32",
  widthDecimal: 0.175,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "49/64",
  od: "31/32",
  widthDecimal: 0.172,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "25/32",
  od: "31/32",
  widthDecimal: 0.167,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "51/64",
  od: "31/32",
  widthDecimal: 0.158,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "13/16",
  od: "31/32",
  widthDecimal: 0.146,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "53/64",
  od: "1 1/32",
  widthDecimal: 0.153,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "27/32",
  od: "1 1/32",
  widthDecimal: 0.164,
});

// idx_data_insert_sizesRAW.push({
//   type_id: INSERT_TURBO_QUAD_2_SEMI,
//   size: "55/64",
//   od: "1 1/32",
//   widthDecimal: 0.0,
// });

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "7/8",
  od: "1 1/32",
  widthDecimal: 0.137,
});

// idx_data_insert_sizesRAW.push({
//   type_id: INSERT_TURBO_QUAD_2_SEMI,
//   size: "57/64",
//   od: "1 1/32",
//   widthDecimal: 0.0,
// });

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_2_SEMI,
  size: "29/32",
  od: "1 1/32",
  widthDecimal: 0.136,
});

// INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT
idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "---",
  od: "",
  widthDecimal: 0.0,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "19/32",
  od: "31/32",
  widthDecimal: 0.249,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "39/64",
  od: "31/32",
  widthDecimal: 0.244,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "5/8",
  od: "31/32",
  widthDecimal: 0.24,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "41/64",
  od: "31/32",
  widthDecimal: 0.23,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "21/32",
  od: "31/32",
  widthDecimal: 0.221,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "43/64",
  od: "31/32",
  widthDecimal: 0.215,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "11/16",
  od: "31/32",
  widthDecimal: 0.209,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "45/64",
  od: "31/32",
  widthDecimal: 0.195,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "23/32",
  od: "31/32",
  widthDecimal: 0.182,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "47/64",
  od: "31/32",
  widthDecimal: 0.179,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "3/4",
  od: "31/32",
  widthDecimal: 0.177,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "49/64",
  od: "31/32",
  widthDecimal: 0.169,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "25/32",
  od: "31/32",
  widthDecimal: 0.161,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "51/64",
  od: "31/32",
  widthDecimal: 0.154,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "13/16",
  od: "31/32",
  widthDecimal: 0.147,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "53/64",
  od: "1 1/32",
  widthDecimal: 0.138,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "27/32",
  od: "1 1/32",
  widthDecimal: 0.13,
});

// idx_data_insert_sizesRAW.push({
//   type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
//   size: "55/64",
//   od: "1 1/32",
//   widthDecimal: 0.0,
// });

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "7/8",
  od: "1 1/32",
  widthDecimal: 0.124,
});

// idx_data_insert_sizesRAW.push({
//   type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
//   size: "57/64",
//   od: "1 1/32",
//   widthDecimal: 0.0,
// });

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT,
  size: "29/32",
  od: "1 1/32",
  widthDecimal: 0.122,
});

// INSERT_TURBO_QUAD_CLASSIC_POWER_LIFT
idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "---",
  od: "",
  widthDecimal: 0.0,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "19/32",
  od: "31/32",
  widthDecimal: 0.249,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "39/64",
  od: "31/32",
  widthDecimal: 0.244,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "5/8",
  od: "31/32",
  widthDecimal: 0.24,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "41/64",
  od: "31/32",
  widthDecimal: 0.23,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "21/32",
  od: "31/32",
  widthDecimal: 0.221,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "43/64",
  od: "31/32",
  widthDecimal: 0.215,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "11/16",
  od: "31/32",
  widthDecimal: 0.209,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "45/64",
  od: "31/32",
  widthDecimal: 0.195,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "23/32",
  od: "31/32",
  widthDecimal: 0.182,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "47/64",
  od: "31/32",
  widthDecimal: 0.179,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "3/4",
  od: "31/32",
  widthDecimal: 0.177,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "49/64",
  od: "31/32",
  widthDecimal: 0.169,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "25/32",
  od: "31/32",
  widthDecimal: 0.161,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "51/64",
  od: "31/32",
  widthDecimal: 0.154,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "13/16",
  od: "31/32",
  widthDecimal: 0.147,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "53/64",
  od: "1 1/32",
  widthDecimal: 0.138,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "27/32",
  od: "1 1/32",
  widthDecimal: 0.13,
});

// idx_data_insert_sizesRAW.push({
//   type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
//   size: "55/64",
//   od: "1 1/32",
//   widthDecimal: 0.0,
// });

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "7/8",
  od: "1 1/32",
  widthDecimal: 0.124,
});

// idx_data_insert_sizesRAW.push({
//   type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
//   size: "57/64",
//   od: "1 1/32",
//   widthDecimal: 0.0,
// });

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_POWER_LIFT,
  size: "29/32",
  od: "1 1/32",
  widthDecimal: 0.122,
});

// INSERT_TURBO_QUAD_CLASSIC_OVAL
idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "---",
  od: "",
  widthDecimal: 0.0,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "19/32",
  od: "31/32",
  widthDecimal: 0.22,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "39/64",
  od: "31/32",
  widthDecimal: 0.207,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "5/8",
  od: "31/32",
  widthDecimal: 0.197,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "41/64",
  od: "31/32",
  widthDecimal: 0.206,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "21/32",
  od: "31/32",
  widthDecimal: 0.193,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "43/64",
  od: "31/32",
  widthDecimal: 0.183,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "11/16",
  od: "31/32",
  widthDecimal: 0.176,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "45/64",
  od: "31/32",
  widthDecimal: 0.169,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "23/32",
  od: "31/32",
  widthDecimal: 0.166,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "47/64",
  od: "31/32",
  widthDecimal: 0.156,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "3/4",
  od: "31/32",
  widthDecimal: 0.15,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "49/64",
  od: "31/32",
  widthDecimal: 0.157,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "25/32",
  od: "31/32",
  widthDecimal: 0.134,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "51/64",
  od: "31/32",
  widthDecimal: 0.128,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "13/16",
  od: "31/32",
  widthDecimal: 0.126,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "53/64",
  od: "1 1/32",
  widthDecimal: 0.119,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "27/32",
  od: "1 1/32",
  widthDecimal: 0.112,
});

// idx_data_insert_sizesRAW.push({
//   type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
//   size: "55/64",
//   od: "1 1/32",
//   widthDecimal: 0.0,
// });

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "7/8",
  od: "1 1/32",
  widthDecimal: 0.117,
});

// idx_data_insert_sizesRAW.push({
//   type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
//   size: "57/64",
//   od: "1 1/32",
//   widthDecimal: 0.0,
// });

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_OVAL,
  size: "29/32",
  od: "1 1/32",
  widthDecimal: 0.101,
});

// INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL
idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "---",
  od: "",
  widthDecimal: 0.0,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "19/32",
  od: "31/32",
  widthDecimal: 0.22,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "39/64",
  od: "31/32",
  widthDecimal: 0.207,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "5/8",
  od: "31/32",
  widthDecimal: 0.197,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "41/64",
  od: "31/32",
  widthDecimal: 0.206,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "21/32",
  od: "31/32",
  widthDecimal: 0.193,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "43/64",
  od: "31/32",
  widthDecimal: 0.183,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "11/16",
  od: "31/32",
  widthDecimal: 0.176,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "45/64",
  od: "31/32",
  widthDecimal: 0.169,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "23/32",
  od: "31/32",
  widthDecimal: 0.166,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "47/64",
  od: "31/32",
  widthDecimal: 0.156,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "3/4",
  od: "31/32",
  widthDecimal: 0.15,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "49/64",
  od: "31/32",
  widthDecimal: 0.157,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "25/32",
  od: "31/32",
  widthDecimal: 0.134,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "51/64",
  od: "31/32",
  widthDecimal: 0.128,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "13/16",
  od: "31/32",
  widthDecimal: 0.126,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "53/64",
  od: "1 1/32",
  widthDecimal: 0.119,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "27/32",
  od: "1 1/32",
  widthDecimal: 0.112,
});

// idx_data_insert_sizesRAW.push({
//   type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
//   size: "55/64",
//   od: "1 1/32",
//   widthDecimal: 0.0,
// });

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "7/8",
  od: "1 1/32",
  widthDecimal: 0.117,
});

// idx_data_insert_sizesRAW.push({
//   type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
//   size: "57/64",
//   od: "1 1/32",
//   widthDecimal: 0.0,
// });

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_CLASSIC_PRO_OVAL,
  size: "29/32",
  od: "1 1/32",
  widthDecimal: 0.101,
});

// INSERT_TURBO_QUAD_SB_POWER_LIFT
idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "---",
  od: "",
  widthDecimal: 0.0,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "19/32",
  od: "31/32",
  widthDecimal: 0.249,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "39/64",
  od: "31/32",
  widthDecimal: 0.244,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "5/8",
  od: "31/32",
  widthDecimal: 0.24,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "41/64",
  od: "31/32",
  widthDecimal: 0.23,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "21/32",
  od: "31/32",
  widthDecimal: 0.221,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "43/64",
  od: "31/32",
  widthDecimal: 0.215,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "11/16",
  od: "31/32",
  widthDecimal: 0.209,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "45/64",
  od: "31/32",
  widthDecimal: 0.195,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "23/32",
  od: "31/32",
  widthDecimal: 0.182,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "47/64",
  od: "31/32",
  widthDecimal: 0.179,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "3/4",
  od: "31/32",
  widthDecimal: 0.177,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "49/64",
  od: "31/32",
  widthDecimal: 0.169,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "25/32",
  od: "31/32",
  widthDecimal: 0.161,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "51/64",
  od: "31/32",
  widthDecimal: 0.154,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "13/16",
  od: "31/32",
  widthDecimal: 0.147,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "53/64",
  od: "1 1/32",
  widthDecimal: 0.138,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "27/32",
  od: "1 1/32",
  widthDecimal: 0.13,
});

// idx_data_insert_sizesRAW.push({
//   type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
//   size: "55/64",
//   od: "1 1/32",
//   widthDecimal: 0.0,
// });

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "7/8",
  od: "1 1/32",
  widthDecimal: 0.124,
});

// idx_data_insert_sizesRAW.push({
//   type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
//   size: "57/64",
//   od: "1 1/32",
//   widthDecimal: 0.0,
// });

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_POWER_LIFT,
  size: "29/32",
  od: "1 1/32",
  widthDecimal: 0.122,
});

// INSERT_TURBO_QUAD_SB_SEMI
idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "---",
  od: "",
  widthDecimal: 0.0,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "19/32",
  od: "31/32",
  widthDecimal: 0.256,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "39/64",
  od: "31/32",
  widthDecimal: 0.245,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "5/8",
  od: "31/32",
  widthDecimal: 0.243,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "41/64",
  od: "31/32",
  widthDecimal: 0.232,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "21/32",
  od: "31/32",
  widthDecimal: 0.227,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "43/64",
  od: "31/32",
  widthDecimal: 0.22,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "11/16",
  od: "31/32",
  widthDecimal: 0.213,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "45/64",
  od: "31/32",
  widthDecimal: 0.194,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "23/32",
  od: "31/32",
  widthDecimal: 0.19,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "47/64",
  od: "31/32",
  widthDecimal: 0.184,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "3/4",
  od: "31/32",
  widthDecimal: 0.175,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "49/64",
  od: "31/32",
  widthDecimal: 0.172,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "25/32",
  od: "31/32",
  widthDecimal: 0.167,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "51/64",
  od: "31/32",
  widthDecimal: 0.158,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "13/16",
  od: "31/32",
  widthDecimal: 0.146,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "53/64",
  od: "1 1/32",
  widthDecimal: 0.153,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "27/32",
  od: "1 1/32",
  widthDecimal: 0.164,
});

// idx_data_insert_sizesRAW.push({
//   type_id: INSERT_TURBO_QUAD_SB_SEMI,
//   size: "55/64",
//   od: "1 1/32",
//   widthDecimal: 0.0,
// });

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "7/8",
  od: "1 1/32",
  widthDecimal: 0.137,
});

// idx_data_insert_sizesRAW.push({
//   type_id: INSERT_TURBO_QUAD_SB_SEMI,
//   size: "57/64",
//   od: "1 1/32",
//   widthDecimal: 0.0,
// });

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_QUAD_SB_SEMI,
  size: "29/32",
  od: "1 1/32",
  widthDecimal: 0.136,
});

// INSERT_TURBO_MISS_QUAD_OVAL
idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: "---",
  od: "",
  widthDecimal: 0.0,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: "17/32",
  od: "7/8",
  widthDecimal: 0.198,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: "35/64",
  od: "7/8",
  widthDecimal: 0.192,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: "9/16",
  od: "7/8",
  widthDecimal: 0.186,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: "37/64",
  od: "7/8",
  widthDecimal: 0.18,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: "19/32",
  od: "7/8",
  widthDecimal: 0.174,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: "39/64",
  od: "7/8",
  widthDecimal: 0.167,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: "5/8",
  od: "7/8",
  widthDecimal: 0.161,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: "41/64",
  od: "7/8",
  widthDecimal: 0.155,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: "21/32",
  od: "7/8",
  widthDecimal: 0.149,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: "43/64",
  od: "7/8",
  widthDecimal: 0.142,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: "11/16",
  od: "7/8",
  widthDecimal: 0.136,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: "45/64",
  od: "7/8",
  widthDecimal: 0.13,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: "23/32",
  od: "7/8",
  widthDecimal: 0.124,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: "47/64",
  od: "7/8",
  widthDecimal: 0.118,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_OVAL,
  size: "3/4",
  od: "7/8",
  widthDecimal: 0.112,
});

// INSERT_TURBO_MISS_QUAD_POWER_OVAL
idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: "---",
  od: "",
  widthDecimal: 0.0,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: "17/32",
  od: "7/8",
  widthDecimal: 0.229,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: "35/64",
  od: "7/8",
  widthDecimal: 0.222,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: "9/16",
  od: "7/8",
  widthDecimal: 0.215,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: "37/64",
  od: "7/8",
  widthDecimal: 0.208,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: "19/32",
  od: "7/8",
  widthDecimal: 0.201,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: "39/64",
  od: "7/8",
  widthDecimal: 0.194,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: "5/8",
  od: "7/8",
  widthDecimal: 0.187,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: "41/64",
  od: "7/8",
  widthDecimal: 0.18,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: "21/32",
  od: "7/8",
  widthDecimal: 0.173,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: "43/64",
  od: "7/8",
  widthDecimal: 0.166,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: "11/16",
  od: "7/8",
  widthDecimal: 0.159,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: "45/64",
  od: "7/8",
  widthDecimal: 0.152,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: "23/32",
  od: "7/8",
  widthDecimal: 0.145,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: "47/64",
  od: "7/8",
  widthDecimal: 0.138,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_TURBO_MISS_QUAD_POWER_OVAL,
  size: "3/4",
  od: "7/8",
  widthDecimal: 0.131,
});

// INSERT_CONTOUR_SUPERSOFT
idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: "---",
  od: "",
  widthDecimal: 0,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: "19/32",
  od: "31/32",
  widthDecimal: 0.275,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: "5/8",
  od: "31/32",
  widthDecimal: 0.26,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: "21/32",
  od: "31/32",
  widthDecimal: 0.245,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: "11/16",
  od: "31/32",
  widthDecimal: 0.23,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: "23/32",
  od: "31/32",
  widthDecimal: 0.215,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: "3/4",
  od: "31/32",
  widthDecimal: 0.2,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: "25/32",
  od: "31/32",
  widthDecimal: 0.185,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: "13/16",
  od: "31/32",
  widthDecimal: 0.17,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: "27/32",
  od: "31/32",
  widthDecimal: 0.155,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: "7/8",
  od: "31/32",
  widthDecimal: 0.14,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SUPERSOFT,
  size: "29/32",
  od: "31/32",
  widthDecimal: 0.125,
});

// INSERT_CONTOUR_SEMI_CERISE
idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: "---",
  od: "",
  widthDecimal: 0.0,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: "19/32",
  od: "31/32",
  widthDecimal: 0.29,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: "5/8",
  od: "31/32",
  widthDecimal: 0.275,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: "21/32",
  od: "31/32",
  widthDecimal: 0.26,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: "11/16",
  od: "31/32",
  widthDecimal: 0.245,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: "23/32",
  od: "31/32",
  widthDecimal: 0.23,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: "3/4",
  od: "31/32",
  widthDecimal: 0.215,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: "25/32",
  od: "31/32",
  widthDecimal: 0.2,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: "13/16",
  od: "31/32",
  widthDecimal: 0.185,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: "27/32",
  od: "31/32",
  widthDecimal: 0.17,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: "7/8",
  od: "31/32",
  widthDecimal: 0.155,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SEMI_CERISE,
  size: "29/32",
  od: "31/32",
  widthDecimal: 0.14,
});

// INSERT_CONTOUR_SILICONE (Contour Oval)
idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SILICONE,
  size: "---",
  od: "",
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SILICONE,
  size: "19/32",
  od: "31/32",
  widthDecimal: 0.24,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SILICONE,
  size: "5/8",
  od: "31/32",
  widthDecimal: 0.225,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SILICONE,
  size: "21/32",
  od: "31/32",
  widthDecimal: 0.21,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SILICONE,
  size: "11/16",
  od: "31/32",
  widthDecimal: 0.195,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SILICONE,
  size: "23/32",
  od: "31/32",
  widthDecimal: 0.18,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SILICONE,
  size: "3/4",
  od: "31/32",
  widthDecimal: 0.165,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SILICONE,
  size: "25/32",
  od: "31/32",
  widthDecimal: 0.15,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SILICONE,
  size: "13/16",
  od: "31/32",
  widthDecimal: 0.135,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SILICONE,
  size: "27/32",
  od: "31/32",
  widthDecimal: 0.12,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SILICONE,
  size: "7/8",
  od: "31/32",
  widthDecimal: 0.105,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_CONTOUR_SILICONE,
  size: "29/32",
  od: "31/32",
  widthDecimal: 0.09,
});

// INSERT_VISE_POWER_LIFT
idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "---",
  od: "",
  widthDecimal: 0.0,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "0: 9/16",
  od: "31/32",
  widthDecimal: 0.299,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "0.5: 37/64",
  od: "31/32",
  widthDecimal: 0.292,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "1: 19/32",
  od: "31/32",
  widthDecimal: 0.285,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "1.5: 39/64",
  od: "31/32",
  widthDecimal: 0.278,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "2: 5/8",
  od: "31/32",
  widthDecimal: 0.271,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "2.5: 41/64",
  od: "31/32",
  widthDecimal: 0.264,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "3: 21/32",
  od: "31/32",
  widthDecimal: 0.257,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "3.5: 43/64",
  od: "31/32",
  widthDecimal: 0.25,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "4: 11/16",
  od: "31/32",
  widthDecimal: 0.243,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "4.5: 45/64",
  od: "31/32",
  widthDecimal: 0.236,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "5: 23/32",
  od: "31/32",
  widthDecimal: 0.229,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "5.5: 47/64",
  od: "31/32",
  widthDecimal: 0.222,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "6: 3/4",
  od: "31/32",
  widthDecimal: 0.215,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "6.5: 49/64",
  od: "31/32",
  widthDecimal: 0.208,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "7: 25/32",
  od: "31/32",
  widthDecimal: 0.201,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "7.5: 51/64",
  od: "31/32",
  widthDecimal: 0.194,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "8: 13/16",
  od: "31/32",
  widthDecimal: 0.187,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "8.5: 53/64",
  od: "1 1/32",
  widthDecimal: 0.214,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "9: 27/32",
  od: "1 1/32",
  widthDecimal: 0.207,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "9.5: 55/64",
  od: "1 1/32",
  widthDecimal: 0.2,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "10: 7/8",
  od: "1 1/32",
  widthDecimal: 0.193,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "10.5: 57/64",
  od: "1 1/32",
  widthDecimal: 0.186,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT,
  size: "11: 29/32",
  od: "1 1/32",
  widthDecimal: 0.179,
});

// INSERT_VISE_SEMI
idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: "---",
  od: "",
  widthDecimal: 0.0,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: "0: 9/16",
  od: "31/32",
  widthDecimal: 0.295,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: "0.5: 37/64",
  od: "31/32",
  widthDecimal: 0.288,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: "1: 19/32",
  od: "31/32",
  widthDecimal: 0.281,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: "1.5: 39/64",
  od: "31/32",
  widthDecimal: 0.274,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: "2: 5/8",
  od: "31/32",
  widthDecimal: 0.267,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: "2.5: 41/64",
  od: "31/32",
  widthDecimal: 0.26,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: "3: 21/32",
  od: "31/32",
  widthDecimal: 0.253,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: "3.5: 43/64",
  od: "31/32",
  widthDecimal: 0.246,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: "4: 11/16",
  od: "31/32",
  widthDecimal: 0.239,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: "4.5: 45/64",
  od: "31/32",
  widthDecimal: 0.232,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: "5: 23/32",
  od: "31/32",
  widthDecimal: 0.225,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: "5.5: 47/64",
  od: "31/32",
  widthDecimal: 0.218,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: "6: 3/4",
  od: "31/32",
  widthDecimal: 0.211,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: "6.5: 49/64",
  od: "31/32",
  widthDecimal: 0.204,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: "7: 25/32",
  od: "31/32",
  widthDecimal: 0.197,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: "7.5: 51/64",
  od: "31/32",
  widthDecimal: 0.19,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: "8: 13/16",
  od: "31/32",
  widthDecimal: 0.183,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: "8.5: 53/64",
  od: "1 1/32",
  widthDecimal: 0.191,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: "9: 27/32",
  od: "1 1/32",
  widthDecimal: 0.184,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: "9.5: 55/64",
  od: "1 1/32",
  widthDecimal: 0.177,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: "10: 7/8",
  od: "1 1/32",
  widthDecimal: 0.17,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: "10.5: 57/64",
  od: "1 1/32",
  widthDecimal: 0.163,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI,
  size: "11: 29/32",
  od: "1 1/32",
  widthDecimal: 0.156,
});

// INSERT_VISE_POWER_OVAL
idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "---",
  od: "",
  widthDecimal: 0.0,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "0: 9/16",
  od: "31/32",
  widthDecimal: 0.282,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "0.5: 37/64",
  od: "31/32",
  widthDecimal: 0.275,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "1: 19/32",
  od: "31/32",
  widthDecimal: 0.268,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "1.5: 39/64",
  od: "31/32",
  widthDecimal: 0.261,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "2: 5/8",
  od: "31/32",
  widthDecimal: 0.254,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "2.5: 41/64",
  od: "31/32",
  widthDecimal: 0.247,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "3: 21/32",
  od: "31/32",
  widthDecimal: 0.24,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "3.5: 43/64",
  od: "31/32",
  widthDecimal: 0.233,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "4: 11/16",
  od: "31/32",
  widthDecimal: 0.226,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "4.5: 45/64",
  od: "31/32",
  widthDecimal: 0.219,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "5: 23/32",
  od: "31/32",
  widthDecimal: 0.212,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "5.5: 47/64",
  od: "31/32",
  widthDecimal: 0.205,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "6: 3/4",
  od: "31/32",
  widthDecimal: 0.198,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "6.5: 49/64",
  od: "31/32",
  widthDecimal: 0.191,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "7: 25/32",
  od: "31/32",
  widthDecimal: 0.184,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "7.5: 51/64",
  od: "31/32",
  widthDecimal: 0.177,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "8: 13/16",
  od: "31/32",
  widthDecimal: 0.17,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "8.5: 53/64",
  od: "1 1/32",
  widthDecimal: 0.178,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "9: 27/32",
  od: "1 1/32",
  widthDecimal: 0.171,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "9.5: 55/64",
  od: "1 1/32",
  widthDecimal: 0.164,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "10: 7/8",
  od: "1 1/32",
  widthDecimal: 0.157,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "10.5: 57/64",
  od: "1 1/32",
  widthDecimal: 0.15,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL,
  size: "11: 29/32",
  od: "1 1/32",
  widthDecimal: 0.143,
});

// INSERT_VISE_OVAL
idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: "---",
  od: "",
  widthDecimal: 0.0,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: "0: 9/16",
  od: "31/32",
  widthDecimal: 0.236,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: "0.5: 37/64",
  od: "31/32",
  widthDecimal: 0.229,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: "1: 19/32",
  od: "31/32",
  widthDecimal: 0.222,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: "1.5: 39/64",
  od: "31/32",
  widthDecimal: 0.215,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: "2: 5/8",
  od: "31/32",
  widthDecimal: 0.208,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: "2.5: 41/64",
  od: "31/32",
  widthDecimal: 0.201,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: "3: 21/32",
  od: "31/32",
  widthDecimal: 0.194,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: "3.5: 43/64",
  od: "31/32",
  widthDecimal: 0.187,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: "4: 11/16",
  od: "31/32",
  widthDecimal: 0.18,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: "4.5: 45/64",
  od: "31/32",
  widthDecimal: 0.173,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: "5: 23/32",
  od: "31/32",
  widthDecimal: 0.166,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: "5.5: 47/64",
  od: "31/32",
  widthDecimal: 0.159,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: "6: 3/4",
  od: "31/32",
  widthDecimal: 0.152,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: "6.5: 49/64",
  od: "31/32",
  widthDecimal: 0.145,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: "7: 25/32",
  od: "31/32",
  widthDecimal: 0.138,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: "7.5: 51/64",
  od: "31/32",
  widthDecimal: 0.131,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: "8: 13/16",
  od: "31/32",
  widthDecimal: 0.124,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: "8.5: 53/64",
  od: "1 1/32",
  widthDecimal: 0.147,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: "9: 27/32",
  od: "1 1/32",
  widthDecimal: 0.14,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: "9.5: 55/64",
  od: "1 1/32",
  widthDecimal: 0.133,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: "10: 7/8",
  od: "1 1/32",
  widthDecimal: 0.126,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: "10.5: 57/64",
  od: "1 1/32",
  widthDecimal: 0.119,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL,
  size: "11: 29/32",
  od: "1 1/32",
  widthDecimal: 0.112,
});

// INSERT_VISE_SILICONE
idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SILICONE,
  size: "---",
  od: "",
  widthDecimal: 0.0,
});

// idx_data_insert_sizesRAW.push({
//   type_id: INSERT_VISE_SILICONE,
//   size: "0: 9/16",
//   od: "31/32",
//   widthDecimal: 0.0,
// });

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SILICONE,
  size: "1: 19/32",
  od: "31/32",
  widthDecimal: 0.26,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SILICONE,
  size: "2: 5/8",
  od: "31/32",
  widthDecimal: 0.245,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SILICONE,
  size: "3: 21/32",
  od: "31/32",
  widthDecimal: 0.23,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SILICONE,
  size: "4: 11/16",
  od: "31/32",
  widthDecimal: 0.215,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SILICONE,
  size: "5: 23/32",
  od: "31/32",
  widthDecimal: 0.2,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SILICONE,
  size: "6: 3/4",
  od: "31/32",
  widthDecimal: 0.185,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SILICONE,
  size: "7: 25/32",
  od: "31/32",
  widthDecimal: 0.17,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SILICONE,
  size: "8: 13/16",
  od: "31/32",
  widthDecimal: 0.155,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SILICONE,
  size: "9: 27/32",
  od: "1 1/32",
  widthDecimal: 0.14,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SILICONE,
  size: "10: 7/8",
  od: "1 1/32",
  widthDecimal: 0.125,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SILICONE,
  size: "11: 29/32",
  od: "1 1/32",
  widthDecimal: 0.11,
});

// INSERT_VISE_GRAPE_NUBS
idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "---",
  od: "",
  widthDecimal: 0.0,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "0.5: 37/64",
  od: "31/32",
  widthDecimal: 0.229,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "1: 19/32",
  od: "31/32",
  widthDecimal: 0.222,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "1.5: 39/64",
  od: "31/32",
  widthDecimal: 0.215,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "2: 5/8",
  od: "31/32",
  widthDecimal: 0.208,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "2.5: 41/64",
  od: "31/32",
  widthDecimal: 0.201,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "3: 21/32",
  od: "31/32",
  widthDecimal: 0.194,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "3.5: 43/64",
  od: "31/32",
  widthDecimal: 0.187,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "4: 11/16",
  od: "31/32",
  widthDecimal: 0.18,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "4.5: 45/64",
  od: "31/32",
  widthDecimal: 0.173,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "5: 23/32",
  od: "31/32",
  widthDecimal: 0.166,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "5.5: 47/64",
  od: "31/32",
  widthDecimal: 0.159,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "6: 3/4",
  od: "31/32",
  widthDecimal: 0.152,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "6.5: 49/64",
  od: "31/32",
  widthDecimal: 0.145,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "7: 25/32",
  od: "31/32",
  widthDecimal: 0.138,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "7.5: 51/64",
  od: "31/32",
  widthDecimal: 0.131,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "8: 13/16",
  od: "31/32",
  widthDecimal: 0.124,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "8.5: 53/64",
  od: "1 1/32",
  widthDecimal: 0.147,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "9: 27/32",
  od: "1 1/32",
  widthDecimal: 0.14,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "9.5: 55/64",
  od: "1 1/32",
  widthDecimal: 0.133,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "10: 7/8",
  od: "1 1/32",
  widthDecimal: 0.126,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "10.5: 57/64",
  od: "1 1/32",
  widthDecimal: 0.119,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_GRAPE_NUBS,
  size: "11: 29/32",
  od: "1 1/32",
  widthDecimal: 0.112,
});

// INSERT_VISE_POWER_LIFT_7_8
idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT_7_8,
  size: "---",
  od: "",
  widthDecimal: 0.0,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT_7_8,
  size: "-1: 17/32",
  od: "7/8",
  widthDecimal: 0.262,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT_7_8,
  size: "-0.5: 35/64",
  od: "7/8",
  widthDecimal: 0.2545,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT_7_8,
  size: "0: 9/16",
  od: "7/8",
  widthDecimal: 0.247,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT_7_8,
  size: "0.5: 37/64",
  od: "7/8",
  widthDecimal: 0.2395,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT_7_8,
  size: "1: 19/32",
  od: "7/8",
  widthDecimal: 0.232,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT_7_8,
  size: "1.5: 39/64",
  od: "7/8",
  widthDecimal: 0.2245,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT_7_8,
  size: "2: 5/8",
  od: "7/8",
  widthDecimal: 0.217,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT_7_8,
  size: "2.5: 41/64",
  od: "7/8",
  widthDecimal: 0.2095,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT_7_8,
  size: "3: 21/32",
  od: "7/8",
  widthDecimal: 0.202,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT_7_8,
  size: "3.5: 43/64",
  od: "7/8",
  widthDecimal: 0.1945,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT_7_8,
  size: "4: 11/16",
  od: "7/8",
  widthDecimal: 0.187,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT_7_8,
  size: "4.5: 45/64",
  od: "7/8",
  widthDecimal: 0.1795,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT_7_8,
  size: "5: 23/32",
  od: "7/8",
  widthDecimal: 0.172,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT_7_8,
  size: "5.5: 47/64",
  od: "7/8",
  widthDecimal: 0.1645,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_LIFT_7_8,
  size: "6: 3/4",
  od: "7/8",
  widthDecimal: 0.157,
});

// idx_data_insert_sizesRAW.push({
//   type_id: INSERT_VISE_POWER_LIFT_7_8,
//   size: "6.5: 49/64",
//   od: "7/8",
//   widthDecimal: 0.0,
// });

// INSERT_VISE_POWER_OVAL_7_8
idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL_7_8,
  size: "---",
  od: "",
  widthDecimal: 0.0,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL_7_8,
  size: "-1: 17/32",
  od: "7/8",
  widthDecimal: 0.25,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL_7_8,
  size: "-0.5: 35/64",
  od: "7/8",
  widthDecimal: 0.2425,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL_7_8,
  size: "0: 9/16",
  od: "7/8",
  widthDecimal: 0.235,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL_7_8,
  size: "0.5: 37/64",
  od: "7/8",
  widthDecimal: 0.2275,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL_7_8,
  size: "1: 19/32",
  od: "7/8",
  widthDecimal: 0.22,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL_7_8,
  size: "1.5: 39/64",
  od: "7/8",
  widthDecimal: 0.2125,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL_7_8,
  size: "2: 5/8",
  od: "7/8",
  widthDecimal: 0.205,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL_7_8,
  size: "2.5: 41/64",
  od: "7/8",
  widthDecimal: 0.1975,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL_7_8,
  size: "3: 21/32",
  od: "7/8",
  widthDecimal: 0.19,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL_7_8,
  size: "3.5: 43/64",
  od: "7/8",
  widthDecimal: 0.1825,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL_7_8,
  size: "4: 11/16",
  od: "7/8",
  widthDecimal: 0.175,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL_7_8,
  size: "4.5: 45/64",
  od: "7/8",
  widthDecimal: 0.1675,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL_7_8,
  size: "5: 23/32",
  od: "7/8",
  widthDecimal: 0.16,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL_7_8,
  size: "5.5: 47/64",
  od: "7/8",
  widthDecimal: 0.1525,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_POWER_OVAL_7_8,
  size: "6: 3/4",
  od: "7/8",
  widthDecimal: 0.145,
});

// idx_data_insert_sizesRAW.push({
//   type_id: INSERT_VISE_POWER_OVAL_7_8,
//   size: "6.5: 49/64",
//   od: "7/8",
//   widthDecimal: 0.0,
// });

// INSERT_VISE_SEMI_7_8
idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI_7_8,
  size: "---",
  od: "",
  widthDecimal: 0.0,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI_7_8,
  size: "-1: 17/32",
  od: "7/8",
  widthDecimal: 0.263,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI_7_8,
  size: "-0.5: 35/64",
  od: "7/8",
  widthDecimal: 0.2555,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI_7_8,
  size: "0: 9/16",
  od: "7/8",
  widthDecimal: 0.248,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI_7_8,
  size: "0.5: 37/64",
  od: "7/8",
  widthDecimal: 0.2405,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI_7_8,
  size: "1: 19/32",
  od: "7/8",
  widthDecimal: 0.233,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI_7_8,
  size: "1.5: 39/64",
  od: "7/8",
  widthDecimal: 0.2255,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI_7_8,
  size: "2: 5/8",
  od: "7/8",
  widthDecimal: 0.218,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI_7_8,
  size: "2.5: 41/64",
  od: "7/8",
  widthDecimal: 0.2105,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI_7_8,
  size: "3: 21/32",
  od: "7/8",
  widthDecimal: 0.203,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI_7_8,
  size: "3.5: 43/64",
  od: "7/8",
  widthDecimal: 0.1955,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI_7_8,
  size: "4: 11/16",
  od: "7/8",
  widthDecimal: 0.188,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI_7_8,
  size: "4.5: 45/64",
  od: "7/8",
  widthDecimal: 0.1805,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI_7_8,
  size: "5: 23/32",
  od: "7/8",
  widthDecimal: 0.173,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI_7_8,
  size: "5.5: 47/64",
  od: "7/8",
  widthDecimal: 0.1655,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_SEMI_7_8,
  size: "6: 3/4",
  od: "7/8",
  widthDecimal: 0.158,
});

// idx_data_insert_sizesRAW.push({
//   type_id: INSERT_VISE_SEMI_7_8,
//   size: "6.5: 49/64",
//   od: "7/8",
//   widthDecimal: 0.0,
// });

// INSERT_VISE_OVAL_7_8
idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL_7_8,
  size: "---",
  od: "",
  widthDecimal: 0.0,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL_7_8,
  size: "-1: 17/32",
  od: "7/8",
  widthDecimal: 0.203,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL_7_8,
  size: "-0.5: 35/64",
  od: "7/8",
  widthDecimal: 0.1955,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL_7_8,
  size: "0: 9/16",
  od: "7/8",
  widthDecimal: 0.188,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL_7_8,
  size: "0.5: 37/64",
  od: "7/8",
  widthDecimal: 0.1805,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL_7_8,
  size: "1: 19/32",
  od: "7/8",
  widthDecimal: 0.173,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL_7_8,
  size: "1.5: 39/64",
  od: "7/8",
  widthDecimal: 0.1655,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL_7_8,
  size: "2: 5/8",
  od: "7/8",
  widthDecimal: 0.158,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL_7_8,
  size: "2.5: 41/64",
  od: "7/8",
  widthDecimal: 0.1505,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL_7_8,
  size: "3: 21/32",
  od: "7/8",
  widthDecimal: 0.143,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL_7_8,
  size: "3.5: 43/64",
  od: "7/8",
  widthDecimal: 0.1355,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL_7_8,
  size: "4: 11/16",
  od: "7/8",
  widthDecimal: 0.128,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL_7_8,
  size: "4.5: 45/64",
  od: "7/8",
  widthDecimal: 0.1205,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL_7_8,
  size: "5: 23/32",
  od: "7/8",
  widthDecimal: 0.113,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL_7_8,
  size: "5.5: 47/64",
  od: "7/8",
  widthDecimal: 0.1055,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_VISE_OVAL_7_8,
  size: "6: 3/4",
  od: "7/8",
  widthDecimal: 0.098,
});

// idx_data_insert_sizesRAW.push({
//   type_id: INSERT_VISE_OVAL_7_8,
//   size: "6.5: 49/64",
//   od: "7/8",
//   widthDecimal: 0.0,
// });

// INSERT_ULTIMATE_TLO_OVAL
idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "---",
  od: "",
  widthDecimal: 0.0,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "9/16",
  od: "31/32",
  widthDecimal: 0.236,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "37/64",
  od: "31/32",
  widthDecimal: 0.229,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "19/32",
  od: "31/32",
  widthDecimal: 0.222,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "39/64",
  od: "31/32",
  widthDecimal: 0.215,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "5/8",
  od: "31/32",
  widthDecimal: 0.208,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "41/64",
  od: "31/32",
  widthDecimal: 0.201,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "21/32",
  od: "31/32",
  widthDecimal: 0.194,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "43/64",
  od: "31/32",
  widthDecimal: 0.187,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "11/16",
  od: "31/32",
  widthDecimal: 0.18,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "45/64",
  od: "31/32",
  widthDecimal: 0.173,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "23/32",
  od: "31/32",
  widthDecimal: 0.166,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "47/64",
  od: "31/32",
  widthDecimal: 0.159,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "3/4",
  od: "31/32",
  widthDecimal: 0.152,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "49/64",
  od: "31/32",
  widthDecimal: 0.145,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "25/32",
  od: "31/32",
  widthDecimal: 0.138,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "51/64",
  od: "31/32",
  widthDecimal: 0.131,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "13/16",
  od: "31/32",
  widthDecimal: 0.124,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "53/64",
  od: "1 1/32",
  widthDecimal: 0.147,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "27/32",
  od: "1 1/32",
  widthDecimal: 0.14,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "55/64",
  od: "1 1/32",
  widthDecimal: 0.133,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "7/8",
  od: "1 1/32",
  widthDecimal: 0.126,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "57/64",
  od: "1 1/32",
  widthDecimal: 0.119,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL,
  size: "29/32",
  od: "1 1/32",
  widthDecimal: 0.112,
});

// INSERT_ULTIMATE_TLO_LIFT
idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "---",
  od: "",
  widthDecimal: 0.0,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "9/16",
  od: "31/32",
  widthDecimal: 0.299,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "37/64",
  od: "31/32",
  widthDecimal: 0.292,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "19/32",
  od: "31/32",
  widthDecimal: 0.285,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "39/64",
  od: "31/32",
  widthDecimal: 0.278,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "5/8",
  od: "31/32",
  widthDecimal: 0.271,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "41/64",
  od: "31/32",
  widthDecimal: 0.264,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "21/32",
  od: "31/32",
  widthDecimal: 0.257,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "43/64",
  od: "31/32",
  widthDecimal: 0.25,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "11/16",
  od: "31/32",
  widthDecimal: 0.243,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "45/64",
  od: "31/32",
  widthDecimal: 0.236,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "23/32",
  od: "31/32",
  widthDecimal: 0.229,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "47/64",
  od: "31/32",
  widthDecimal: 0.222,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "3/4",
  od: "31/32",
  widthDecimal: 0.215,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "49/64",
  od: "31/32",
  widthDecimal: 0.208,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "25/32",
  od: "31/32",
  widthDecimal: 0.201,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "51/64",
  od: "31/32",
  widthDecimal: 0.194,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "13/16",
  od: "31/32",
  widthDecimal: 0.187,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "53/64",
  od: "1 1/32",
  widthDecimal: 0.214,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "27/32",
  od: "1 1/32",
  widthDecimal: 0.207,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "55/64",
  od: "1 1/32",
  widthDecimal: 0.2,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "7/8",
  od: "1 1/32",
  widthDecimal: 0.193,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "57/64",
  od: "1 1/32",
  widthDecimal: 0.186,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT,
  size: "29/32",
  od: "1 1/32",
  widthDecimal: 0.179,
});

// INSERT_ULTIMATE_TLO_OVAL_7_8
idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL_7_8,
  size: "---",
  od: "",
  widthDecimal: 0.0,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL_7_8,
  size: "17/32",
  od: "7/8",
  widthDecimal: 0.203,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL_7_8,
  size: "9/16",
  od: "7/8",
  widthDecimal: 0.188,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL_7_8,
  size: "19/32",
  od: "7/8",
  widthDecimal: 0.173,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL_7_8,
  size: "5/8",
  od: "7/8",
  widthDecimal: 0.158,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL_7_8,
  size: "21/32",
  od: "7/8",
  widthDecimal: 0.143,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL_7_8,
  size: "11/16",
  od: "7/8",
  widthDecimal: 0.128,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL_7_8,
  size: "23/32",
  od: "7/8",
  widthDecimal: 0.113,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_OVAL_7_8,
  size: "3/4",
  od: "7/8",
  widthDecimal: 0.098,
});

// idx_data_insert_sizesRAW.push({
//   type_id: INSERT_ULTIMATE_TLO_OVAL_7_8,
//   size: "25/32",
//   od: "7/8",
//   widthDecimal: 0.0,
// });

// INSERT_ULTIMATE_TLO_LIFT_7_8
idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT_7_8,
  size: "---",
  od: "",
  widthDecimal: 0.0,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT_7_8,
  size: "17/32",
  od: "7/8",
  widthDecimal: 0.262,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT_7_8,
  size: "9/16",
  od: "7/8",
  widthDecimal: 0.247,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT_7_8,
  size: "19/32",
  od: "7/8",
  widthDecimal: 0.232,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT_7_8,
  size: "5/8",
  od: "7/8",
  widthDecimal: 0.217,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT_7_8,
  size: "21/32",
  od: "7/8",
  widthDecimal: 0.202,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT_7_8,
  size: "11/16",
  od: "7/8",
  widthDecimal: 0.187,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT_7_8,
  size: "23/32",
  od: "7/8",
  widthDecimal: 0.172,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_ULTIMATE_TLO_LIFT_7_8,
  size: "3/4",
  od: "7/8",
  widthDecimal: 0.157,
});

// INSERT_JOPO_POWER_OVAL
idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_OVAL,
  size: "---",
  od: "",
  widthDecimal: 0.0,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_OVAL,
  size: "19/32",
  od: "31/32",
  widthDecimal: 0.249,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_OVAL,
  size: "39/64",
  od: "31/32",
  widthDecimal: 0.244,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_OVAL,
  size: "5/8",
  od: "31/32",
  widthDecimal: 0.24,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_OVAL,
  size: "41/64",
  od: "31/32",
  widthDecimal: 0.23,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_OVAL,
  size: "21/32",
  od: "31/32",
  widthDecimal: 0.221,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_OVAL,
  size: "43/64",
  od: "31/32",
  widthDecimal: 0.215,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_OVAL,
  size: "11/16",
  od: "31/32",
  widthDecimal: 0.209,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_OVAL,
  size: "45/64",
  od: "31/32",
  widthDecimal: 0.195,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_OVAL,
  size: "23/32",
  od: "31/32",
  widthDecimal: 0.182,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_OVAL,
  size: "47/64",
  od: "31/32",
  widthDecimal: 0.179,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_OVAL,
  size: "3/4",
  od: "31/32",
  widthDecimal: 0.177,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_OVAL,
  size: "49/64",
  od: "31/32",
  widthDecimal: 0.169,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_OVAL,
  size: "25/32",
  od: "31/32",
  widthDecimal: 0.161,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_OVAL,
  size: "51/64",
  od: "31/32",
  widthDecimal: 0.154,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_OVAL,
  size: "13/16",
  od: "31/32",
  widthDecimal: 0.147,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_OVAL,
  size: "53/64",
  od: "1 1/32",
  widthDecimal: 0.138,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_OVAL,
  size: "27/32",
  od: "1 1/32",
  widthDecimal: 0.13,
});

// INSERT_JOPO_OVAL
idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL,
  size: "---",
  od: "",
  widthDecimal: 0.0,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL,
  size: "9/16",
  od: "31/32",
  widthDecimal: 0.236,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL,
  size: "37/64",
  od: "31/32",
  widthDecimal: 0.229,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL,
  size: "19/32",
  od: "31/32",
  widthDecimal: 0.222,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL,
  size: "39/64",
  od: "31/32",
  widthDecimal: 0.215,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL,
  size: "5/8",
  od: "31/32",
  widthDecimal: 0.208,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL,
  size: "41/64",
  od: "31/32",
  widthDecimal: 0.201,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL,
  size: "21/32",
  od: "31/32",
  widthDecimal: 0.194,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL,
  size: "43/64",
  od: "31/32",
  widthDecimal: 0.187,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL,
  size: "11/16",
  od: "31/32",
  widthDecimal: 0.18,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL,
  size: "45/64",
  od: "31/32",
  widthDecimal: 0.173,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL,
  size: "23/32",
  od: "31/32",
  widthDecimal: 0.166,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL,
  size: "47/64",
  od: "31/32",
  widthDecimal: 0.159,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL,
  size: "3/4",
  od: "31/32",
  widthDecimal: 0.152,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL,
  size: "49/64",
  od: "31/32",
  widthDecimal: 0.145,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL,
  size: "25/32",
  od: "31/32",
  widthDecimal: 0.138,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL,
  size: "51/64",
  od: "31/32",
  widthDecimal: 0.131,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL,
  size: "13/16",
  od: "31/32",
  widthDecimal: 0.124,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL,
  size: "53/64",
  od: "1 1/32",
  widthDecimal: 0.147,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL,
  size: "27/32",
  od: "1 1/32",
  widthDecimal: 0.14,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL,
  size: "55/64",
  od: "1 1/32",
  widthDecimal: 0.133,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL,
  size: "7/8",
  od: "1 1/32",
  widthDecimal: 0.126,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL,
  size: "57/64",
  od: "1 1/32",
  widthDecimal: 0.119,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL,
  size: "29/32",
  od: "1 1/32",
  widthDecimal: 0.112,
});

// INSERT_JOPO_OVAL_DOTS
idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "---",
  od: "",
  widthDecimal: 0.0,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "9/16",
  od: "31/32",
  widthDecimal: 0.236,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "37/64",
  od: "31/32",
  widthDecimal: 0.229,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "19/32",
  od: "31/32",
  widthDecimal: 0.222,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "39/64",
  od: "31/32",
  widthDecimal: 0.215,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "5/8",
  od: "31/32",
  widthDecimal: 0.208,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "41/64",
  od: "31/32",
  widthDecimal: 0.201,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "21/32",
  od: "31/32",
  widthDecimal: 0.194,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "43/64",
  od: "31/32",
  widthDecimal: 0.187,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "11/16",
  od: "31/32",
  widthDecimal: 0.18,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "45/64",
  od: "31/32",
  widthDecimal: 0.173,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "23/32",
  od: "31/32",
  widthDecimal: 0.166,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "47/64",
  od: "31/32",
  widthDecimal: 0.159,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "3/4",
  od: "31/32",
  widthDecimal: 0.152,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "49/64",
  od: "31/32",
  widthDecimal: 0.145,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "25/32",
  od: "31/32",
  widthDecimal: 0.138,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "51/64",
  od: "31/32",
  widthDecimal: 0.131,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "13/16",
  od: "31/32",
  widthDecimal: 0.124,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "53/64",
  od: "1 1/32",
  widthDecimal: 0.147,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "27/32",
  od: "1 1/32",
  widthDecimal: 0.14,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "55/64",
  od: "1 1/32",
  widthDecimal: 0.133,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "7/8",
  od: "1 1/32",
  widthDecimal: 0.126,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "57/64",
  od: "1 1/32",
  widthDecimal: 0.119,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_OVAL_DOTS,
  size: "29/32",
  od: "1 1/32",
  widthDecimal: 0.112,
});

// INSERT_JOPO_POWER_FLAT
idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_FLAT,
  size: "---",
  od: "",
  widthDecimal: 0.0,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_FLAT,
  size: "19/32",
  od: "31/32",
  widthDecimal: 0.249,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_FLAT,
  size: "39/64",
  od: "31/32",
  widthDecimal: 0.244,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_FLAT,
  size: "5/8",
  od: "31/32",
  widthDecimal: 0.24,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_FLAT,
  size: "41/64",
  od: "31/32",
  widthDecimal: 0.23,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_FLAT,
  size: "21/32",
  od: "31/32",
  widthDecimal: 0.221,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_FLAT,
  size: "43/64",
  od: "31/32",
  widthDecimal: 0.215,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_FLAT,
  size: "11/16",
  od: "31/32",
  widthDecimal: 0.209,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_FLAT,
  size: "45/64",
  od: "31/32",
  widthDecimal: 0.195,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_FLAT,
  size: "23/32",
  od: "31/32",
  widthDecimal: 0.182,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_FLAT,
  size: "47/64",
  od: "31/32",
  widthDecimal: 0.179,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_FLAT,
  size: "3/4",
  od: "31/32",
  widthDecimal: 0.177,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_FLAT,
  size: "49/64",
  od: "31/32",
  widthDecimal: 0.169,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_FLAT,
  size: "25/32",
  od: "31/32",
  widthDecimal: 0.161,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_FLAT,
  size: "51/64",
  od: "31/32",
  widthDecimal: 0.154,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_FLAT,
  size: "13/16",
  od: "31/32",
  widthDecimal: 0.147,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_FLAT,
  size: "53/64",
  od: "1 1/32",
  widthDecimal: 0.138,
});

idx_data_insert_sizesRAW.push({
  type_id: INSERT_JOPO_POWER_FLAT,
  size: "27/32",
  od: "1 1/32",
  widthDecimal: 0.13,
});

// const insert_sizes = idx_data_insert_sizesRAW.map((size) => {
//   return { type: size.type_id, value: R.trim([size.size, size.od].join("\t")) };
// });

// // group inserr_sizes by type
// const grouped_insert_sizes = R.toPairs(
//   R.mapObjIndexed(
//     (arrValues) => arrValues.map(R.prop("value")).join("\n"),
//     R.groupBy(R.prop("type"), insert_sizes)
//   )
// );

// // console.log("excel sizes", grouped_insert_sizes);

// console.log(
//   "excel sizes",
//   grouped_insert_sizes
//     .map((pair) => ["INSERT TYPE", pair[0]].join("\t") + "\n" + pair[1])
//     .join("\n")
// );

export const idx_data_insert_sizes = R.map((size) => {
  const noDecimalSize = R.pipe(
    R.assocPath(["size"], R.trim(R.path(["size"], size))),
    R.assocPath(["od"], R.trim(R.path(["od"], size)))
  )(size);
  const realSize =
    noDecimalSize.size.indexOf(": ") >= 0
      ? noDecimalSize.size.split(": ")[1]
      : noDecimalSize.size;
  const fraction = new Fraction(realSize);
  return {
    ...noDecimalSize,
    decimal:
      noDecimalSize.size === "---"
        ? ""
        : (fraction.numerator / fraction.denominator).toFixed(3),
  };
})(idx_data_insert_sizesRAW);
